<template lang="pug">
  #TrialPlan
    .activity-page.text-center(v-if="isInited")
      .banner-area
        img(
          src='@/assets/images/trial-plan/reserve_banner.png?v=1'
        )
      .activity-area(
        v-if="record"
      )
        .title-area
          h4 親愛的 {{ record.name }}
          h4
            |  您的訂閱期間
            br
            |  {{ formatDate(record.event_start_date, 'date') }} ~ {{ formatDate(record.event_end_date, 'date') }}
        .point-area
          .point(
            v-for="(status, index) in record.list"
          )
            img(
              v-if="takeStatus(status) == 0 || takeStatus(status) == 1"
              src='@/assets/images/trial-plan/is_can_take.png'
            )
            img(
              v-else
              src='@/assets/images/trial-plan/is_cant_take.png'
            )
            .status 
              img(:src="require(`@/assets/images/trial-plan/take_status${takeStatus(status)}.png`)")
            .detail
              p 可於
                span {{ formatDate(status.start_at) }}~
              p
                span {{ formatDate(status.end_at) }}
                | 內申請
            .take-date(
              v-if="takeStatus(status) == 1"
            )
              p
                | 已於
                br
                | {{ status.takeDate }}
                br
                |  完成{{ status.sendStatus }}
            .activity
              img(v-if="record.is_back_new_member === false" :src="require(`@/assets/images/trial-plan/activity${index+1}.png`)")
              img(v-else :src="require(`@/assets/images/trial-plan/activity${index+1}_2024.png`)")

      .info-area
        img(v-if="record.is_back_new_member === true" src='@/assets/images/trial-plan/info_2024.png')
        img(v-else-if="record.year === 2023" src='@/assets/images/trial-plan/info_2023.png')
        img(v-else src='@/assets/images/trial-plan/info.png?v=2')


    

</template>

<script>
import { mapState } from "vuex";
import { M_MY_SA_INDEX } from "@/router/member/my-sa";

export default {
  name: "TrialPlanActivity",

  data() {
    return {
      isInited: 0,
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit("toggleLoading", false);
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: "載入中，請稍候",
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
    // 取得個人資料
    vm.$store.dispatch("member_trial_plan/getSampleRecordHandler").then(() => {
      vm.$swal.close();
      vm.isInited = 1;
      if (!this.record.is_bind) {
        //尚未綁定
        vm.$router.push({
          name: M_MY_SA_INDEX,
        });
      }
    });
  },
  methods: {
    takeStatus(status) {
      const { is_can_take, take_status, take_date, end_at } = status;
      const isEnd = this.duringDateHandler(end_at); //超過可領時間尚未領取

      if (is_can_take === true) {
        // 可以領取
        return 0;
      } else {
        if (take_status === 1) {
          //已領
          const formatDay = this.formatDate(take_date);
          let curday = new Date(formatDay);
          let currMonth = curday.getMonth();
          let currYear = curday.getFullYear();
          let newDay = new Date();
          const today = new Date();

          newDay.setYear(currYear);
          newDay.setMonth(currMonth + 1);
          newDay.setDate(4);

          if (today >= newDay) {
            let newYear = newDay.getFullYear();
            let newMonth = newDay.getMonth();
            status.takeDate = `${newYear}/${
              newMonth + 1 < 10 ? "0" + (newMonth + 1) : newMonth + 1
            }/04`;
            status.sendStatus = "寄送";
          } else {
            status.takeDate = this.formatDate(take_date);
            status.sendStatus = "申請";
          }
          return 1;
        }
        if (!isEnd) {
          return 2; //超過可領時間尚未領取
        }
        return 3; //時間未到不可領
      }
    },
    duringDateHandler(endDateStr) {
      const dateType = endDateStr.replaceAll("-", "/");
      const curDate = new Date();
      const endDate = new Date(dateType);
      if (curDate <= endDate) {
        return true;
      }
      return false;
    },
    formatDate(time, type) {
      if (!time) return;
      if (type === "date") return time.replaceAll("-", "/");
      return time.split(" ")[0].replaceAll("-", "/");
    },
  },
  computed: {
    ...mapState({
      record: (state) => state.member_trial_plan.record,
    }),
  },
};
</script>

<style lang="scss" scoped>
@mixin pad {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin mobile {
  @media (max-width: 375px) {
    @content;
  }
}

@mixin small-mobile {
  @media (max-width: 320px) {
    @content;
  }
}

img {
  max-width: 100%;
  height: auto;
  vertical-align: center;
  border-style: none;
}
/*------ activity-page ------*/
.text-center {
  max-width: 540px;
  margin: 0 auto;
  min-height: 100%;
  text-align: center;
  padding: 0;
  // overflow-y: scroll;
  // overflow-x: hidden;
  // -ms-overflow-style: none;
  // scrollbar-width: none;
  // &::-webkit-scrollbar {
  // 	display: none;
  // }
}
.activity-area {
  color: #fff;
  max-width: 100%;
  // background: url(../../../assets/images/trial-plan/bg_form.png) top center repeat;
  background: #000;
  background-size: 100%;
}
.title-area {
  padding: 4% 0 2% 0;
  h4 {
    font-weight: normal;
    font-size: 1.3rem;
    letter-spacing: 1.5px;
    line-height: 1.5;
    @include pad {
      font-size: 1.6rem;
    }
  }
}
.point-area {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 1% 7% 3% 7%;
  .point {
    flex: 0 0 47%;
    // padding: 2.2% 2.5%;
    position: relative;
    margin-bottom: 5%;
    .status {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 5;
    }
    .activity {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }
    .detail {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 5%;

      @include pad {
        bottom: 5.5%;
      }
      @include small-mobile {
        bottom: 3.5%;
      }
      // margin-top: -2.5rem;
      p {
        margin-bottom: 0;
        font-size: 12px;
        color: #000;
        line-height: 14px;
        @include pad {
          font-size: 16px;
          line-height: 18px;
        }
        @include small-mobile {
          line-height: 12px;
        }
      }
      span {
        color: #b90320;
        font-size: 14px;
        padding: 0 2%;
        @include pad {
          font-size: 18px;
        }
        @include small-mobile {
          font-size: 12px;
        }
      }
    }
    .take-date {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 14%;
      z-index: 10;
      p {
        color: #000;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        @include pad {
          font-size: 24px;
          line-height: 28px;
        }
        @include small-mobile {
          font-size: 16px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
